// Tracking
export const TRACK_ADDRESS_NOT_DELIVERABLE = 'TRACK_ADDRESS_NOT_DELIVERABLE';
export const TRACK_APP_BANNER_CLOSE = 'TRACK_APP_BANNER_CLOSE';
export const TRACK_APP_BANNER_VISIT = 'TRACK_APP_BANNER_VISIT';
export const TRACK_ADDRESS_REFINE = 'TRACK_ADDRESS_REFINE';
export const TRACK_CLICK_APP_DOWNLOAD = 'TRACK_CLICK_APP_DOWNLOAD';
export const TRACK_ENTERED_LOCATION = 'TRACK_ENTERED_LOCATION';
export const TRACK_INVITE_FRIENDS = 'TRACK_INVITE_FRIENDS';
export const TRACK_ORDER_HELP_ACTIONS = 'TRACK_ORDER_HELP_ACTIONS';
export const TRACK_SESSION_STARTED = 'TRACK_SESSION_STARTED';
export const TRACK_SHOW_REFERRAL_PROMPT = 'TRACK_SHOW_REFERRAL_PROMPT';
export const TRACK_VIEWED_HOMEPAGE = 'TRACK_VIEWED_HOMEPAGE';
export const TRACK_HOMEPAGE_LOCATION_SEARCH_SEEN = 'TRACK_HOMEPAGE_LOCATION_SEARCH_SEEN';
export const TRACK_ORDER_STATUS_PAGE = 'TRACK_ORDER_STATUS_PAGE';
export const TRACK_ORDER_HISTORY_PAGE = 'TRACK_ORDER_HISTORY_PAGE';
export const TRACK_SEARCH_LOCATION_CHANGE = 'TRACK_SEARCH_LOCATION_CHANGE';
export const TRACK_MEAL_CARD_MODAL_OPEN = 'TRACK_MEAL_CARD_MODAL_OPEN';
export const TRACK_MEAL_CARD_ISSUER_CLICK = 'TRACK_MEAL_CARD_ISSUER_CLICK';
export const TRACK_MEAL_CARD_AUTH_SUCCESS = 'TRACK_MEAL_CARD_AUTH_SUCCESS';
export const TRACK_CLICKED_MEAL_CARD_BANNER = 'TRACK_CLICKED_MEAL_CARD_BANNER';
export const TRACK_INVITE_BANNER_CLOSE = 'TRACK_INVITE_BANNER_CLOSE';
export const TRACK_INVITE_BANNER_CLICK = 'TRACK_INVITE_BANNER_CLICK';
export const TRACK_INVITE_BANNER_VISIT = 'TRACK_INVITE_BANNER_VISIT';
export const TRACK_VIEWED_REFERRAL = 'TRACK_VIEWED_REFERRAL';
export const TRACK_TAPPED_LOCATION_PICKER = 'TRACK_TAPPED_LOCATION_PICKER';
export const TRACK_TAPPED_TIME_PICKER = 'TRACK_TAPPED_TIME_PICKER';
export const TRACK_TAPPED_FILTER = 'TRACK_TAPPED_FILTER';
export const TRACK_TAPPED_FILTER_OPTION = 'TRACK_TAPPED_FILTER_OPTION';
export const TRACK_VIEWED_MOBILE_FILTERS = 'TRACK_VIEWED_MOBILE_FILTERS';
export const TRACK_VIEWED_HOME = 'TRACK_VIEWED_HOME';
export const TRACK_VIEWED_COLLECTION = 'TRACK_VIEWED_COLLECTION';
export const TRACK_TAPPED_MY_ACCOUNT = 'TRACK_TAPPED_MY_ACCOUNT';
export const TRACK_TAPPED_LOGIN = 'TRACK_TAPPED_LOGIN';
export const TRACK_CLICKED_SHARE_TRACKER = 'TRACK_CLICKED_SHARE_TRACKER';
export const TRACK_COPIED_SHARE_TRACKER_LINK = 'TRACK_COPIED_SHARE_TRACKER_LINK';
export const TRACK_VIEWED_SHARED_ORDER_PAGE = 'TRACK_VIEWED_SHARED_ORDER_PAGE';
export const TRACK_TIME_TO_INTERACTIVE = 'TRACK_TIME_TO_INTERACTIVE';
export const TRACK_TAPPED_FILTER_ICON = 'TRACK_TAPPED_FILTER_ICON';
export const TRACK_TOGGLE_FILTER_SECTION = 'TRACK_TOGGLE_FILTER_SECTION';
export const TRACK_TAPPED_LAYOUT_BLOCK = 'TRACK_TAPPED_LAYOUT_BLOCK';
export const TRACK_TAPPED_LAYOUT = 'TRACK_TAPPED_LAYOUT';
export const TRACK_TAPPED_SEARCH_BAR = 'TRACK_TAPPED_SEARCH_BAR';
export const TRACK_TYPED_IN_SEARCH_BAR = 'TRACK_TYPED_IN_SEARCH_BAR';
export const TRACK_TAPPED_SEARCH_RESULT = 'TRACK_TAPPED_SEARCH_RESULT';
export const TRACK_VIEWED_SEARCH_DROP_DOWN = 'TRACK_VIEWED_SEARCH_DROP_DOWN';
export const TRACK_GEOLOCATION_AVAILABLE = 'TRACK_GEOLOCATION_AVAILABLE';
export const TRACK_GEOLOCATION_ATTEMPT = 'TRACK_GEOLOCATION_ATTEMPT';
